<template>
  <slot />
</template>

<script>
export default { name: 'CursorBase' };
</script>

<script setup>
import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { provideCursorState } from './useCursorState.js';
import { useCursorStyleSync } from '../../../../common/utilities/useCursorStyleSync.js';

const store = useStore();

const cursorType = computed(() =>
  store.state.portfolio?.templateSettings?.cursorType || 'DEFAULT'
);
const isPreviewMode = computed(() => store.state.cursorPreviewMode);

useCursorStyleSync(cursorType, isPreviewMode);

// Module-level variables persist across remounts so the cursor reappears at the
// last known position without waiting for the next mousemove event.
let _lastX = 0;
let _lastY = 0;

const { x, y } = provideCursorState();

// Seed with last known position on remount
x.value = _lastX;
y.value = _lastY;

// Keep module-level cache in sync
watch(x, v => { _lastX = v; });
watch(y, v => { _lastY = v; });
</script>
